import React from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Portal';
import {
  Box,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import messages from './messages';

const HavingTroubleLoggingInModal = ({ open, closeModal, title }) => {
  return (
    <Modal
      title={title}
      open={open}
      onClose={closeModal}
      icon={<AlertInfoIcon sx={{ position: 'relative', top: -2 }} />}
    >
      <Box component={'ol'} sx={{ paddingInlineStart: 'inherit' }}>
        {Object.values(messages.list).map(({ title, description }, i) => (
          <Box
            component={'li'}
            key={`troubleLoggingInMessage_${i}`}
            marginBottom={1}
          >
            <Typography variant={'body2'}>{title}</Typography>
            <Typography>{description}</Typography>
          </Box>
        ))}
      </Box>
    </Modal>
  );
};

export default HavingTroubleLoggingInModal;
